<template>	   
  <v-card>
    <v-card-text>
      <v-layout row wrap>
        <v-flex xs6 pa-1> 
          <label for="">Variables</label>
          <v-autocomplete solo
            :items="variables"
            item-value="id"
            item-text="name"
            v-model="filters.id_variable"
            label="Variables"
          >
            <template v-slot:item="data">
              <v-list-item-action @click="data.item.active = !data.item.active">
                <v-icon>fas fa-subscript</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title v-html="data.item.name"></v-list-item-title>
                <v-list-item-sub-title>Tipo: {{ data.item.category }} | Nivel: {{ data.item.level }}  </v-list-item-sub-title>
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex xs6 pa-1> 
          <label for="">Localidades</label>
          <v-autocomplete solo
            :items="localities"
            item-text="label" 
            return-object
            item-value="value" multiple
            v-model="filters.points"
            label="Localidades"
          >
          <template v-slot:prepend-item>
            <v-list-item
              ripple
              @click="toggleLocality"
            >
              <v-list-item-action>
                <v-icon :color="filters.points.length > 0 ? 'indigo darken-4' : ''">{{ iconLocalities }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Seleccionar todos</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
          </template>
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index < 6">
              <span>{{ item.label }}</span>
            </v-chip>
            <span
              v-if="index === 6"
              class="grey--text caption"
            >(+{{ filters.points.length - 6 }} Otros)</span>
          </template>
          <template v-slot:item="data">             
            <v-list-item-action @click="data.item.active = !data.item.active">
              <v-icon :color="data.item.active ? 'indigo darken-4' : ''">{{ data.item.active ? 'fas fa-check-square' : 'mdi-checkbox-blank-outline' }}</v-icon>
            </v-list-item-action>
            <v-list-item-content @click="data.item.active = !data.item.active">
              <v-list-item-title v-html="data.item.label"></v-list-item-title>
              <v-list-item-sub-title><strong>Provincia:</strong> {{ data.item.province }}</v-list-item-sub-title>
            </v-list-item-content>
          </template>
        </v-autocomplete>
        </v-flex>
        <v-flex xs6 pa-1> 
          <label for="">Fecha</label>
          <v-text-field
            name="name" v-model="filters.week"
            label="Fecha" solo
            id="id" type="date"
          ></v-text-field>
        </v-flex>
        <v-flex xs6 pa-1> 
          <label for="">Formato</label>
          <v-select
            :items="format"
            name="year"
            type="number"
            v-model="filters.year"
            label="Formato del archivo" solo
            id="id" 
          ></v-select>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-actions>
      <v-btn color="success">Generar</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
	export default{
		created() {
			
		},
		mounted(){
		  this.getVariables();
      this.getLocalities();
    },
		props: [
			
		],
		data(){
			return {
        headers: [
          { text: 'Nombre', value: 'name'},
          { text: 'Valor', value: 'value' },
          { text: 'Tipo', value: 'type' },
          { text: 'Acciones', value: 'actions' },
        ],
        searchDatatable: '',
        baseRoute: process.env.VUE_APP_URL + 'api/gis',
        filters: {
          id_variable: '',
          id_point: '',
          dateInit: '',
          dateEnd: '',
          followLocate: false,
          date: '',
          points: []
        },
        variables: [],
				localities: [], //Apidefinition
        format: ['ESRI SHAPE FILE', 'CSV', 'JPG', 'PNG', 'TIFF'], //Apidefinition
				noDataError: false,
        rotate: 270,
			}
		},
		methods: {
			getLocalities(){
				//window.clearInterval(this.interval);
				axios.get(this.baseRoute + '/district/getSelect/habilited').then((res) => {
					this.localities = res.data;
				}).catch((error) => {

				});
			},
      getVariables(){
        axios.get(this.baseRoute + '/variables/getSelect').then((res) => {
          this.variables = res.data;
        }).catch((error) => {
          this.alert = {
            messague: 'Hay un error interno en el servidor pruebe nuevamente mas tarde',
            color: 'error',
            active: true,
            icon: 'fas fa-bell',            
          }
        });
      },
      toggleLocality () {
        this.$nextTick(() => {
          if (this.selectAllLocalities) {
            this.filters.points = []
            this.localities.map(function(item){
              item.active = false;
            })
          } else {
            this.filters.points = this.localities.map(function(item){
              item.active = true
              return item.value;
            })
          }
        })
      },
		},
		watch: {
			
		},
		computed: {
      selectAllLocalities () {
        return this.filters.points.length === this.localities.length
      },
      selectSomeLocalities () {
        return this.filters.points.length > 0 && !this.selectAllLocalities
      },
      iconLocalities () {
        if (this.selectAllLocalities) return 'mdi-close-box'
        if (this.selectSomeLocalities) return 'mdi-minus-box'
        return 'mdi-checkbox-blank-outline'
      },
		},
	}
</script>